/**
 * assert — 코드를 쓰며 세운 가정을 문서이자 감시자로 만든다 (fail fast).
 *
 * 가정이 깨지면 그 자리에서 즉시 죽는다 — 이상한 값이 조용히 흘러가
 * 며칠 뒤 엉뚱한 곳에서 터지는 것보다 발생 지점의 명확한 에러가 백배 싸다.
 * console.assert 는 프로덕션에서 죽지 않으므로 쓰지 않는다.
 * (컨벤션 §4 — 포프 I-26·34 채택, 2026-08-31 판정: "CI/CD 보다 윗단계")
 *
 * `asserts condition` 반환형 덕에 통과 이후 코드에서 타입도 좁혀진다:
 *   assert(row.id != null, '저장 안 된 행');
 *   row.id  // ← 여기서부터 number 로 취급
 */
/** V8(Node·Chrome) 확장 — lib.dom 타입엔 없어 여기서만 선언. 다른 엔진에선 undefined. */
type ErrorConstructorWithCapture = ErrorConstructor & {
  captureStackTrace?: (target: object, cutFrom?: (...args: never[]) => unknown) => void;
};

export function assert(condition: unknown, message: string): asserts condition {
  if (condition) return;
  const failure = new Error(`ASSERT 실패: ${message}`);
  // 스택 맨 위를 assert 안이 아니라 assert 를 부른 자리로 — 깨진 가정이 있는 곳이 첫 줄에 온다.
  // V8(Node·Chrome) 전용 API 라 있을 때만; 없으면 스택 첫 줄이 assert 인 채로 던진다(메시지가 자리를 말한다).
  (Error as ErrorConstructorWithCapture).captureStackTrace?.(failure, assert);
  throw failure;
}
